@if (isMarketOpen) {
  <mat-expansion-panel class="exp-panel" [expanded]="true">
    <mat-expansion-panel-header class="exp-panel-header white-panel-indicator">
      <mat-panel-title class="exp-panel-title">
        <a
          [routerLink]="[
            '/app/main',
            {
              outlets: {
                navigation: ['event', market?.eventId],
                content: ['event-markets', market?.eventId],
              },
            },
          ]"
          class="title-anchor">
          @if (isMyMarketsPage) {
            <span>{{ market?.eventName }} - </span>
          }
          @if (market?.providerId === "0") {
            {{ "Match Odds - 0% Commission" | translate }}
          } @else {
            {{ "Bookmaker" | translate }} - {{ market?.type === "MINI_BOOKMAKER" ? market?.name : market?.type }}
          }
        </a>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="bm-table-wrapper">
      @if (featureFlagService.featureFlags$ | async; as flags) {
        @if (flags["autoBookmakerCashOut"] && isZeroPercentMatchOdds && !isMyMarketsPage) {
          <app-cash-out-offer [market]="market" [runnerUpdates]="runnerUpdates" />
        }
      }
      <table>
        <thead>
          <tr>
            <th class="runner-th" colspan="3">
              <span>
                @if (market?.minBet) {
                  {{ "Min Bet" | translate }}: {{ market?.minBet }}&nbsp;&nbsp;
                }
                @if (market?.maxBet) {
                  {{ "Max Bet" | translate }}: {{ market?.maxBet }}
                }
              </span>
            </th>
            <th class="text-center back-th">{{ "Back" | translate }}</th>
            <th class="text-center lay-th">{{ "Lay" | translate }}</th>
            <th colspan="2"></th>
          </tr>
        </thead>
        <tbody>
          @for (runner of market?.runners; track runner?.selectionId) {
            <tr app-b-runner-row [market]="market" [data]="runner" [update]="getRunnerUpdate(runner?.selectionId)"></tr>
          }
        </tbody>
      </table>
      @if (marketStatus() && marketStatus() !== "OPEN") {
        <app-overlay [text]="marketStatus()" />
      }
      @if (!allowPlacement) {
        <app-block-overlay />
      }
    </div>
  </mat-expansion-panel>
}
